var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Snackbar'),_vm._v(" "),_c('Loading'),_vm._v(" "),_c('v-sheet',[_c('Navigation',{attrs:{"active-url":_vm.activeUrl}})],1),_vm._v(" "),_c('v-main',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }